import useDataOptions from '../../app/hooks/useDataOptions'
import { parseLocationsString } from '../selectors'

export default () => {
  const addLocations = useDataOptions(state => state.addLocations)
  const setActiveLocation = useDataOptions(state => state.setActiveLocation)
  return async (route, setActive = true) => {
    const locations = parseLocationsString(route).map(l => l.id)
    addLocations(locations, setActive)
    // If only one location is in URL, add as active location
    if(locations.length === 1) {
      setActiveLocation(locations[0])
    }
    return locations
  }
}
